import { FC } from "react";

import { ThemedFundraiser, ThemedFundraiserProps } from "./ThemedFundraiser";

import { useTranslate } from "@/hooks/useTranslate";

export type ThemedTeamFundraiserProps = Omit<ThemedFundraiserProps, "title" | "subtitle"> & {
  campaignTitle: string;
  totalRaised?: number;
};

export const ThemedTeamFundraiser: FC<ThemedTeamFundraiserProps> = ({
  href,
  imageSrc,
  campaignTitle,
  totalRaised,
  currency,
  ...rest
}) => {
  const { t } = useTranslate();

  return (
    <ThemedFundraiser
      {...rest}
      href={href}
      imageSrc={imageSrc}
      title={campaignTitle}
      subtitle={t("donationForm", "peerToPeer.teamCampaignType")}
      totalRaised={totalRaised}
      currency={currency}
      showFallbackImage
    />
  );
};
